import OrderService from "src/services/OrderService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	CONSTRUCTION_SAVE:"order/construction_save"
};
export const params = {
	id: null,
	client_id: null,
	project: {
		branch_id: null,
		address: null,
		city: null
	},
	measurements: [],
	project_id: "",
	designer: "",
	designer_phone: "",
	customer: "",
	customer_phone: "",
	order_num: "",
	tel: "",
	tel2: "",
	note: "",
	note2: "",
	apartment_num: "",
	apartment_floor: "",
	urgent: 0,
  contact2_tel: ""

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.order,
@property  {array}  modules.orders
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {
		[types.CONSTRUCTION_SAVE](context,data){
			return OrderService.saveConstruction(data);
		}
	},
	types: types
};
export default ModuleCreator("order", OrderService, module, types ,params);
